import { $, $$ } from '@3pc/dom';
import { Marquee } from '@3pc/marquee';
import '../../../../node_modules/@3pc/marquee/lib/marquee.scss';

const marquees = $$('.marquee-wrapper');
const marqueeSection = $('.marquee');

if (marquees.length) {
  marquees.forEach(marquee => {
    const innerElement = $('.marquee__inner', marquee);
    const textElement = $('.marquee__text', marquee);

    const marqueeAnimation = new Marquee(marquee, {
      innerElement,
      textElement,
      speed: 50,
      pauseOnHover: true,
    });

    marqueeAnimation.init();

    // Optional example: Add event listeners to pause/play the animation
    const toggleElement = $('.marquee__button', marqueeSection);
    toggleElement.addEventListener('click', () => marqueeAnimation.toggle());
  });
}
